module.exports = __webpack_public_path__ + "static/media/logo.9686c0b0.jpg";